import { Component, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../Services/user';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';
import { Config } from '../Services/config';
import { User } from '../Models/user';
import { Credentials } from '../Models/credentials';
import { NgForm } from '@angular/forms';
import { GoogleAnalyticsEventsService } from "../Services/google-analytics";


@Component({
  selector: 'app-register',
  templateUrl: '../Templates/register.html',
})


/**
 * Register user. If there is a temporary user active, use that one to
 * register with.
 */
export class RegisterComponent {

  model: User;

  @Input()
  private redirect: boolean = true;

  // Form submitted?
  submitted = false;
  settings: Map<string, any>;
  public pwd_min_length: number = 8;

  errors: any = null;

  constructor(private userService: UserService,
              private router: Router,
              private config: Config,
              private msg: AlertService,
              private gaEventsService: GoogleAnalyticsEventsService,
              private auth: AuthService) {}

  ngOnInit() {

    this.model = new User();

    // Allow tmp user, but ignore possible email
    this.auth.getUser().subscribe(
      user => {
        if (user) {
          this.model = user.clone();
          this.model.email = "";
        }
      }
    );

    this.config.getSettings().subscribe(
      settings => {
        this.settings = settings;
        if ('pwd_min_length' in this.settings) {
          this.pwd_min_length = this.settings['pwd_min_length'];
        }
      }
    );
  }

  /**
   * When registered, navigate to home and show a message.
   */
  registered(user): void {

    this.gaEventsService.emitEvent(
      "Account",
      "Profile created",
      "User created a profile",
    );

    this.submitted = true;
    this.model = user;

    if (this.redirect) {
      this.router.navigate(['/']);
    }

    this.msg.success("User created! Hello " + user.email);
  }

  /**
   * Register user. If user is temporary, use update. After
   * registration, the user is logged in immediately.
   */
  register(form: NgForm): void {

    if (this.submitted) {
      this.msg.error("Form already submitted");
      return;
    }

    /*if (this.model.is_tmp && !this.model.is_tmp) {
      this.model.is_tmp = false;
      this.model.username = this.model.email;

      this.userService.update(this.model).subscribe(
        user => {

          let pwd = {'new_password1': this.model.password,
                     'new_password2': this.model.password_check};

          this.auth.refreshToken().subscribe(
            token => {
              this.userService.resetPwd(user, pwd).subscribe(
                user => {
                  this.registered(user);
                }
              )
            }
          )
        },
        (err: HttpErrorResponse) => {

          this.errors = err.error;

          if (err.error.non_field_errors) {
            this.msg.error(err.error.non_field_errors);
          } else {
            this.msg.error(err.error);
          }
        });
    } else {*/
    this.userService.create(this.model).subscribe(
      user => {
        let credentials = new Credentials(
          this.model.email,
          this.model.password);

        this.auth.login(credentials).subscribe(
          user => {}
        );

        this.registered(user)
      },
      (err: HttpErrorResponse) => {

        this.errors = err.error;

        if (err.error.non_field_errors) {
          this.msg.error(err.error.non_field_errors);
        } else {
          this.msg.error(err.error);
        }
      });
  }

  /**
   * Check whether passwords are touched and the same.
   */
  public checkPassword(pwd1, pwd2): boolean {

    if (!((pwd1.dirty || pwd1.touched) && (pwd2.dirty || pwd2.touched))) {
      return true;
    }

    if (this.model.password != this.model.password_check) {
      return false;
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/register.ts